import { Component, OnInit, Input } from '@angular/core';
import { FilterService } from 'src/app/_services/filter.service';
import { Router } from '@angular/router';
import moment from 'moment';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  standalone: false,
  selector: 'app-filters-info',
  templateUrl: './filters-info.component.html',
  styleUrls: ['./filters-info.component.scss']
})
export class FiltersInfoComponent implements OnInit {
  filtersInfo: any[] = [];
  filtersKey: string[] = []
  @Input() documents: Array<Object> = [];
  constructor(
    private filterService: FilterService,
    private router: Router,
    private authService: AuthService
    ) { }

  ngOnInit(): void {
    this.filtersInfo = this.filterService.getAppliedFiltersList(this.authService.hasSigners());
    this.filtersKey = Object.keys(this.filtersInfo);
  }

  changeFilters(e) {
    e.preventDefault();
    this.router.navigateByUrl('/search');
  }

  hasInfo(filter) {
    return this.filtersInfo[filter];
  }
}
